<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    rent: { type: Object, default: {} },
    simulation: { type: Object, required: true },
  },

  methods: {
    showModal() {
      this.$refs.modalRefinancer.open()
    },
    closeModal() {
      this.$refs.modalRefinancer.close(false)
    },
    getStatusColor(status) {
      switch (status) {
        case 'CREATED':
        case 'NONE':
        case 'EXPIRED':
        case 'ALREADY_ASSIGN':
          return 'gray'
        case 'CLIENT_REQUEST':
        case 'STUDY':
        case 'TO_BE_COMPLETED':
        case 'REQUESTED':
        case 'CLIENT_PROPOSAL':
        case 'PREACCEPTED':
          return '#337ab7'
        case 'ACCEPTEDS':
        case 'ACCEPTED':
        case 'CLIENT_ACCEPTED':
        case 'CLIENT_CONTRACT':
          return 'lightgreen'
        case 'CONDITIONAL':
          return 'green'
        case 'NOT_ACCEPTED':
          return '#f39c12'
        case 'DEFINITIVE_REFUSAL':
        case 'REFUSED':
        case 'CLIENT_REFUSED':
          return 'lightcoral'
        case 'ERROR':
          return 'red'
      }
    },
    selectDecision(selectedDuration, decisionId) {
      this.patchJSON('decisions/' + decisionId + '/selectrent?' + selectedDuration, {}).then(
        (json) => {
          location.reload()
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    eligibleClass(decision) {
      return {
        'text-center': true,
        'text-danger': !(decision.rent && decision.rents),
      }
    },
    getRent(selectedDuration, rents) {
      if (rents) {
        for ([key, rent] of Object.entries(rents)) {
          if (rent.duration === selectedDuration) {
            return this.$n(Number(rent.rent), 'currency')
          }
        }
      }

      return ''
    },
    getMargin(selectedDuration, rents) {
      if (rents) {
        for ([key, rent] of Object.entries(rents)) {
          if (rent.duration === selectedDuration) {
            return this.$n(Number(rent.margin), 'decimal') + '%'
          }
        }
      }

      return this.$t('simulation.result.notEligible')
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-refinancer"
    ref="modalRefinancer"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-lg"
    title-t="simulation.popin.refinancer.title"
    e2e-modal="refinancer"
  >
    <template #body>
      <h5 class="text-center mt-3">{{ $t('simulation.popin.refinancer.message') }}</h5>
      <table class="table table-striped _table-bordered table-hover fs-16">
        <thead>
          <tr>
            <th>{{ $t('simulation.decision.refinancer.name') }}</th>
            <th>{{ $t('simulation.decision.refinancer.rate') }}</th>
            <th class="text-center">
              {{ $t('simulation.decision.refinancer.rent') }}<br />{{ rent.rent }} €<br />{{
                $t('simulation.decision.refinancer.rentMargin')
              }}
            </th>
            <th class="text-center">
              {{ $t('simulation.decision.refinancer.margin') }}<br />{{
                $n(Number(simulation.decisionAmount), 'currency')
              }}<br />{{ $t('simulation.decision.refinancer.marginRent') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dec in simulation.decisions" :key="dec.id">
            <td>
              {{ dec.refinancer.name }}
              <br />
              <div
                class="badge"
                :style="
                  'color:white;background-color:' + getStatusColor(dec.demand === null ? dec.status : dec.demand.status)
                "
                v-html="$t('simulation.status.' + (dec.demand === null ? dec.status : dec.demand.status) + '.label')"
              ></div>
              {{ dec.demand ? setDate(dec.demand.decisionValidity) : '' }}
            </td>
            <td>{{ dec.rent !== null ? $n(Number(dec.rent.purchaseRate), 'decimal') : '' }} %</td>
            <td :class="eligibleClass(dec)">
              {{ getMargin(rent.duration, dec.rents) }}
            </td>
            <td class="text-center text-primary" style="cursor: pointer" @click="selectDecision(rent.duration, dec.id)">
              {{ getRent(rent.duration, dec.rents) }} ({{
                dec.profitability.length > 0 ? $n(Number(dec.profitability[rent.duration]), 'decimal') : 0
              }}%)
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <ButtonAll margin="no" type="information" data-dismiss="modal" label="button.cancel" />
    </template>
  </ModalDialog>
</template>
